import { ThunkType } from "../../../../core/store/reducers";
import createCityApi from "../api/createCity";
import updateCityApi from "../api/updateCity";
import { setFetchState } from "../citiesDataReducer";
import { City } from "../types";

export const upsertCity = (city: City): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return;
  }

  dispatch(setFetchState({ type: "started" }));

  const { userId } = store.data.auth.current.user;
  const result = city.cityId
    ? await dispatch(updateCityApi(userId, city))
    : await dispatch(createCityApi(userId, city));

  if (result && result.resCode === "OK") {
    dispatch(setFetchState({ type: "successful", result: result.resDesc }));
    return result.resDesc;
  } else {
    dispatch(setFetchState({ type: "error", errorCode: result?.resCode }));
  }
};
